package fr.manyverse.app.domain.model

/**
 * Status of a lockpicking challenge.
 */
enum class LockpickingStatus {
    ACTIVE,
    SUCCESS,
    CANCELLED,
    TIMEOUT
}
